import React from 'react';
import { Section } from './ui/Section';
import { Scale, Utensils, ShoppingCart } from 'lucide-react';
import { motion } from 'framer-motion';
export function Sistema3C() {
  return <Section className="bg-sage-light/50 rounded-3xl my-12" data-id="element-176">
      <div className="text-center mb-10" data-id="element-177">
        <h2 className="text-3xl md:text-4xl font-bold mb-2" data-id="element-178">
          El mecanismo: Sistema 3C
        </h2>
        <p className="text-xl text-sage-dark font-medium" data-id="element-179">
          (simple, repetible, real)
        </p>
      </div>

      <div className="space-y-6" data-id="element-180">
        {/* C1 */}
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="bg-white p-6 rounded-2xl shadow-sm" data-id="element-181">
          <div className="flex items-center gap-3 mb-3" data-id="element-182">
            <div className="p-2 bg-cream rounded-lg" data-id="element-183">
              <Scale className="w-6 h-6 text-sage-dark" data-id="element-184" />
            </div>
            <h3 className="text-xl font-bold" data-id="element-185">C1) Carbo controlado</h3>
          </div>
          <p className="text-brown-body pl-14" data-id="element-186">
            Porciones visuales, sin balanza ni calculadora.
          </p>
        </motion.div>

        {/* C2 */}
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.3
      }} className="bg-white p-6 rounded-2xl shadow-sm" data-id="element-187">
          <div className="flex items-center gap-3 mb-3" data-id="element-188">
            <div className="p-2 bg-cream rounded-lg" data-id="element-189">
              <Utensils className="w-6 h-6 text-sage-dark" data-id="element-190" />
            </div>
            <h3 className="text-xl font-bold" data-id="element-191">C2) Combo</h3>
          </div>
          <p className="text-brown-body pl-14 mb-2" data-id="element-192">
            Carbo + proteína + fibra/verduras (y un poco de grasa).
          </p>
          <p className="text-brown-body/80 text-sm pl-14 italic" data-id="element-193">
            Porque una comida que no sostiene, te empuja a picotear después.
          </p>
        </motion.div>

        {/* C3 */}
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4
      }} className="bg-white p-6 rounded-2xl shadow-md border-2 border-sage/20 relative overflow-hidden" data-id="element-194">
          <div className="absolute top-0 right-0 w-16 h-16 bg-sage/10 rounded-bl-full -mr-8 -mt-8" data-id="element-195"></div>

          <div className="flex items-center gap-3 mb-3" data-id="element-196">
            <div className="p-2 bg-sage text-white rounded-lg" data-id="element-197">
              <ShoppingCart className="w-6 h-6" data-id="element-198" />
            </div>
            <h3 className="text-xl font-bold text-sage-dark" data-id="element-199">C3) Cierre</h3>
          </div>
          <p className="text-brown-body pl-14 mb-3" data-id="element-200">
            Lista por pasillos + mini-prep + plan de emergencia.
          </p>
          <p className="text-amber font-medium pl-14" data-id="element-201">
            Acá es donde la mayoría falla. Acá es donde este PDF te sostiene.
          </p>
        </motion.div>
      </div>
    </Section>;
}